<template>
  <div class="page">
    <div class="article-list">
      <div class="article-item" v-for="item in articleList" @click="onArticleItemClick(item)">
        <div class="article-item-title single-line">{{ item.title }}</div>
        <div class="row">
          <img class="article-item-cover" :src="item.cover" alt="">
          <div>
            <div class="article-item-text double-line">{{ item.text }}</div>
            <div class="article-item-address single-line">{{ item.address }}</div>
          </div>
          <div>
            <img class="article-item-phone"
                 src="https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/2026072211205322a51f024ce8d3f39cb69d7c54b06131.png"
                 alt="" @click.stop="onArticleItemPhoneClick(item)">
            <div class="article-item-time single-line">{{ item.createTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <van-pagination v-model="pageCount" :total-items="totalCount" :items-per-page="pageSize"
                    @change="onPaginationChange"></van-pagination>
    <div class="city-title">其他城市</div>
    <div class="city-list row">
      <div class="city-item" v-for="item in cityList" @click="onCityItemClick(item)"
           v-if="item.id!='1'&&item.domain!=domain">{{ item.name }}
      </div>
    </div>
    <div style="height: 12vw"></div>
    <div class="bottom">粤ICP备2025363000号-14</div>
  </div>
</template>

<script>
import api from "@/apis/api";

export default {
  name: "Home",
  data: function () {
    return {
      domain: "",
      articleList: [],
      cityList: [],
      pageCount: 1,
      pageSize: 20,
      totalCount: 0
    }
  },
  mounted: function () {
    this.domain = window.location.hostname.split(".").length >= 3 ? window.location.hostname.split(".")[window.location.hostname.split(".").length - 3] : "";
    this.getArticleList();
    this.getCityList();
  },
  methods: {
    getArticleList: function () {
      var _this = this;
      var data = {
        domain: _this.domain,
        pageCount: _this.pageCount,
        pageSize: _this.pageSize
      };
      api.getArticleList(data).then(function (response) {
        _this.articleList = response.responseData.articleList;
        _this.totalCount = response.responseData.totalCount;
      });
    },
    getCityList: function () {
      var _this = this;
      var data = {};
      api.getCityList(data).then(function (response) {
        _this.cityList = response.responseData.cityList;
      });
    },
    onArticleItemClick: function (item) {
      this.$router.push({name: "article", params: {articleId: item.id}});
    },
    onArticleItemPhoneClick: function (item) {
      window.location.href = "tel:" + item.contactPhone;
    },
    onPaginationChange: function () {
      this.getArticleList();
    },
    onCityItemClick: function (item) {
      window.location.href = window.location.href.replace(this.domain, item.domain);
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background-color: #F2F2F2;
}

.article-list {
  width: 96vw;
  margin-left: 2vw;
  padding-top: 4vw;
}

.article-item {
  width: 92vw;
  height: 32vw;
  margin-bottom: 4vw;
  padding: 2vw;
  border-radius: 2vw;
  background: #FFFFFF;
}

.article-item-title {
  width: 92vw;
  height: 10vw;
  font-size: 4vw;
  line-height: 10vw;
  font-weight: bold;
}

.article-item-cover {
  width: 28vw;
  height: 18vw;
  border-radius: 2vw;
  object-fit: cover;
}

.article-item-text {
  width: 40vw;
  height: 12vw;
  margin-left: 2vw;
  font-size: 3vw;
  line-height: 6vw;
  color: #999999;
}

.article-item-address {
  width: 40vw;
  height: 6vw;
  margin-left: 2vw;
  font-size: 3vw;
  line-height: 6vw;
  color: #999999;
}

.article-item-phone {
  width: 10vw;
  height: 10vw;
  margin-left: 10vw;
  padding: 1vw 0;
  object-fit: cover;
}

.article-item-time {
  width: 20vw;
  height: 6vw;
  margin-left: 2vw;
  font-size: 3vw;
  line-height: 6vw;
  text-align: right;
  color: #999999;
}

.city-title {
  width: 92vw;
  height: 12vw;
  margin-top: 4vw;
  margin-left: 4vw;
  font-size: 5vw;
  line-height: 12vw;
  font-weight: bold;
}

.city-list {
  flex-wrap: wrap;
  padding-bottom: 4vw;
}

.city-item {
  width: 20vw;
  height: 8vw;
  margin-top: 4vw;
  margin-left: 4vw;
  font-size: 4vw;
  line-height: 8vw;
  text-align: center;
  border-radius: 2vw;
  background-color: #DDDDDD;
}

.bottom {
  width: 100%;
  height: 12vw;
  font-size: 3vw;
  line-height: 8vw;
  text-align: center;
}
</style>
